import styled from 'styled-components';

export const CompanyContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const ModalGap = styled.div`
  display: grid;
  gap: 25px;
`;

export const TableCell = styled.div`
  cursor: pointer;
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 500px;
`;

export const ContentWrapper = styled.div`
  margin: auto;
  min-width: 400px;
  display: grid;
  gap: 10px;
  display: grid;
  place-items: center;
`;
